import React, { useState } from 'react';
import {
  View, Text, TextInput, TouchableOpacity,
  StyleSheet, Alert, KeyboardAvoidingView, Platform,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { generateId } from '../../utils/id';
import { useUserStore } from '../../store';

export const PROFILE_KEY = '@lmrun/profile';

export default function OnboardingScreen() {
  const [displayName, setDisplayName] = useState('Runner 1');
  const [loading, setLoading] = useState(false);
  const setProfile = useUserStore((s) => s.setProfile);

  async function handleStart() {
    const name = displayName.trim() || 'Runner 1';
    setLoading(true);
    try {
      const profile = {
        userId: generateId(),
        email: '',
        displayName: name,
        groups: [],
      };
      await AsyncStorage.setItem(PROFILE_KEY, JSON.stringify(profile));
      setProfile(profile);
    } catch (e: any) {
      Alert.alert('Error', 'Could not save profile. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <KeyboardAvoidingView
      style={styles.container}
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
    >
      <Text style={styles.title}>Landmark Run</Text>
      <Text style={styles.subtitle}>Run. Track. Improve.</Text>
      <Text style={styles.prompt}>What should we call you?</Text>

      <TextInput
        style={styles.input}
        placeholder="Your name"
        value={displayName}
        onChangeText={setDisplayName}
        autoFocus
        returnKeyType="go"
        onSubmitEditing={handleStart}
        testID="onboarding-name-input"
      />
      <TouchableOpacity
        style={[styles.button, loading && styles.buttonDisabled]}
        onPress={handleStart}
        disabled={loading}
        testID="onboarding-start-button"
      >
        <Text style={styles.buttonText}>Get Started</Text>
      </TouchableOpacity>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', paddingHorizontal: 32, backgroundColor: '#fff' },
  title: { fontSize: 42, fontWeight: '700', textAlign: 'center', color: '#1a73e8', marginBottom: 4 },
  subtitle: { fontSize: 16, textAlign: 'center', color: '#666', marginBottom: 48 },
  prompt: { fontSize: 18, fontWeight: '600', textAlign: 'center', marginBottom: 16, color: '#333' },
  input: {
    borderWidth: 1, borderColor: '#ccc', borderRadius: 8,
    padding: 14, fontSize: 18, marginBottom: 16, textAlign: 'center',
  },
  button: { backgroundColor: '#1a73e8', borderRadius: 8, padding: 16, alignItems: 'center' },
  buttonDisabled: { opacity: 0.6 },
  buttonText: { color: '#fff', fontSize: 17, fontWeight: '600' },
});
